import { useEffect, useState } from 'react';

export const useHasCamera = () => {
  const [hasCamera, setHasCamera] = useState<boolean | null>(null);
  const loadingCamera = hasCamera === null;

  useEffect(() => {
    const checkHasCamera = async () => {
      if (!navigator.mediaDevices || !('enumerateDevices' in navigator.mediaDevices)) {
        setHasCamera(false);
        return false;
      }

      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasCamera = devices.some(device => device.kind === 'videoinput');
        setHasCamera(hasCamera);
        return true;
      } catch (err) {
        console.error('Error checking camera:', err);
        setHasCamera(false);
        return false;
      } 
    };

    checkHasCamera();
  }, []);

  return { hasCamera, loadingCamera };
};
